export default "__VITE_ASSET__DITkIX89__"